import React from 'react';
import classes from './ShareModal.module.css';

import {
  EmailShareButton,
  // EmailIcon,
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon
  // FacebookMessengerIcon
} from 'react-share';
// import { MdOutlineContentCopy } from 'react-icons/md';
import { SiGmail } from 'react-icons/si';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';
import ModalSkeleton from '../../modals/ModalSkeleton';
import { useTranslation } from 'react-i18next';
import { IoCopy } from 'react-icons/io5';

const ShareModal = ({ show, setShow, selectedLanguage }) => {
  const { t } = useTranslation('propertyDetail', { lng: selectedLanguage });

  const socialIconProps = {
    size: 32
  };

  const title = t('modal.title');
  const url = window.location.href;

  return (
    <ModalSkeleton
      headerClass={classes.headerClass}
      header={t('modal.Share')}
      show={show}
      setShow={setShow}>
      <div className={classes.container}>
        {/* <div className={classes.main}>
          <h1>{t('modal.heading')}</h1>
        </div>
        <div className={classes.subHead}>
          <h4>{t('modal.titleTwo')}</h4>
        </div> */}
        <div className={classes.socialDivs}>
          <div className="row">
            <div className={`col-md-3 ${classes.social}`}>
              <EmailShareButton url={url} quote={title}>
                <SiGmail round color="" />
                {/* <span>{t('overview.gmail')}</span> */}
              </EmailShareButton>
            </div>
            <div className={`col-md-3 ${classes.social}`}>
              <WhatsappShareButton url={url} quote={title}>
                <WhatsappIcon round {...socialIconProps} />
                {/* <span>{t('overview.whatsApp')}</span> */}
              </WhatsappShareButton>
            </div>
            <div className={`col-md-3 ${classes.social}`}>
              <FacebookShareButton url={url} quote={title}>
                <FacebookIcon round {...socialIconProps} />
                {/* <span>{t('overview.facebook')}</span> */}
              </FacebookShareButton>
            </div>
            {/* <div className={`col-md-3 ${classes.social}`}>
              <FacebookShareButton url={url} quote={title}>
                <FacebookMessengerIcon round {...socialIconProps} />
                {/* <span>{t('overview.messenger')}</span> * /}
              </FacebookShareButton>
            </div> */}
            <div className={`col-md-3 ${classes.social}`}>
              <TwitterShareButton url={url} quote={title}>
                <TwitterIcon round {...socialIconProps} />
                {/* <span>{t('overview.twitter')}</span> */}
              </TwitterShareButton>
            </div>

            <div className={`col-md-12 ${classes.social} c-p`}>
              <CopyToClipboard
                text={window.location.href}
                onCopy={() => toast.success(`${t('message.onCopy')}`)}>
                <div className={`${classes.social_inner}`}>
                  <span>{window.location.href}</span>
                  <IoCopy size={22} color="#00A997" />
                </div>
              </CopyToClipboard>
            </div>
          </div>
        </div>
      </div>
    </ModalSkeleton>
  );
};

export default ShareModal;
